var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "directions_black_24dp 1",
    clipPath: "url(#clip0_4091_19858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0839 6.17599L7.82802 0.92016C7.39052 0.48266 6.62052 0.476827 6.17719 0.92016L0.927187 6.17016C0.472188 6.62516 0.472188 7.36016 0.927187 7.81516L6.17719 13.0652C6.40469 13.2927 6.70219 13.4035 6.99969 13.4035C7.29719 13.4035 7.59469 13.2927 7.82219 13.0652L13.0664 7.82099C13.5272 7.37766 13.533 6.64266 13.0839 6.17599ZM7.00552 12.2427L1.75552 6.99266L7.00552 1.74266L12.2555 6.99266L7.00552 12.2427ZM4.66635 6.41516V8.74849H5.83302V6.99849H8.16635V8.45683L10.208 6.41516L8.16635 4.37349V5.83183H5.24969C4.92885 5.83183 4.66635 6.09433 4.66635 6.41516Z",
    fill: "#808190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_19858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWays);
export default __webpack_public_path__ + "static/media/ways.766d436044a37c7461887d773fb680f8.svg";
export { ForwardRef as ReactComponent };